import {
  Edit,
  ReferenceInput,
  SelectInput,
  SimpleForm,
  TextInput,
  required,
  usePermissions,
} from 'react-admin';
import { PERMISSIONS } from '../../constants';

const choices = [
  {
    value: 'chain',
    label: "Rede",
  },
  {
    value: 'company',
    label: "Transportadora",
  },
];

const edit = props => {

  const { permissions } = usePermissions();

  const choices = [
    ...(permissions.includes(PERMISSIONS.ADMIN_PROFILE) ? [{
      value: 'admin',
      label: "Admin",
    }] : []),
    {
      value: 'chain',
      label: "Rede",
    },
    {
      value: 'company',
      label: "Transportadora",
    },
  ];

  return (
    <Edit {...props} title="Editar permissão">
      <SimpleForm>
        <TextInput source="name" label="Nome" InputProps={{ autoComplete: 'off' }} validate={required()} />
        <TextInput source="label" label="Descrição" InputProps={{ autoComplete: 'off' }} validate={required()} />
        <ReferenceInput
          source="groupId"
          reference="permission-groups"
          sort={{ field: 'name', order: 'ASC' }}
          //@ts-ignore
          perPage={null}
          allowEmpty>
          <SelectInput optionText="name" label="Grupo" />
        </ReferenceInput>
        <SelectInput
          choices={choices}
          source="type"
          label="Tipo"
          optionValue="value"
          optionText="label"
        />
      </SimpleForm>
    </Edit>
  );
}
export default edit;